import { SET_YEARS } from './actionTypes';
import xws from 'api/xws/';
import qs from 'query-string';

// Selectors
import { getWebkey } from 'store/reducers/queryParams/selectors';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Constants
import { getService } from 'constants/ajax';

export const getYears = make => async (dispatch, getState) => {
  const yearsService = getService('years');
  yearsService.setPathVars({ make });
  yearsService.setCallBacks(dispatch(ajaxCallbacks()));
  const {
    data: { years }
  } = await xws(yearsService).post(
    yearsService.getPath(),
    qs.stringify({
      webKey: getWebkey(getState()),
      scheduledOnly: 0
    })
  );
  if (years) {
    dispatch(setYears(years));
    return years;
  }
};

export function setYears(years) {
  return {
    type: SET_YEARS,
    payload: years
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers/years/actions.js